import styled from 'styled-components';
import { Typography } from '../../global/theme';

const Header = styled.div`
  padding: 14px 24px;
  display: flex;
  align-items: center;
  gap: 8px;
  border-bottom: 0.5px solid var(--border-primary);
  p {
    ${Typography.heading_md};
    color: var(--text-primary);
    margin: 0;
  }
`;
const Content = styled.div`
  max-width: 425px;
  width: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
const Icons = styled.div`
  padding: 4px;
  background-color: var(--background-primary);
  box-shadow: var(--shadow-modal);
  width: max-content;
  display: flex;
  border-radius: 6px;
`;
const Heading = styled.h1`
  ${Typography.heading_lg};
  color: var(--text-primary);
  text-align: center;
  margin: 28px 0;
`;
const BodySection = styled.div``;
const Title = styled.h3`
  ${Typography.body_lg_semibold};
  color: var(--text-primary);
  text-align: center;
  margin: 0 0 8px;
`;
const Caption = styled.div`
  display: flex;
  gap: 8px;
  padding: 12px 0;
  border-bottom: 0.5px solid var(--border-primary);
  p {
    margin: 0;
    ${Typography.body_md_medium};
    color: var(--text-secondary);
  }
`;
const CaptionIcon = styled.div``;
const IconsSection = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
`;
const ButtonSection = styled.div`
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 28px;
`;
export { Header, BodySection, Caption, CaptionIcon, Content, Heading, Icons, Title, IconsSection, ButtonSection };
